import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';
// Import JSX Modules
import Price          from './price';
import ProgressButton from '../_utils/progress-button';
// Import JS Modules
import { PrismUI, builderDispatch } from '../_utils/ui';
import genericHelpers               from '../_utils/generic-helpers';
import translate                    from '../_utils/tools/translate';
import Currency                     from '../_utils/tools/currency';
import QuantityPricingTools         from './quantity-pricing-tools';
import UrlBuilder                   from '../_utils/url-building';

// -----------------------------------------------------------
//  PriceAndProductCreate
// -----------------------------------------------------------
var PriceAndProductCreate = createReactClass({
  render() {
    if (this.props.products.length === 0)
      return null;

    const { product, $price } = (() => {
      if (this.props.products.length === 1) {
        const [product] = this.props.products;

        return {
          product,
          $price: this.renderPrice(product, true)
        };
      }

      const product = this.productWithMinimumPrice();

      return {
        product,
        $price: this.renderPrice(product)
      };
    })();

    const $quantityDropdown = (() => {
      if (product.show_quantity_dropdown) {
        return (
          <div className="col-12">
            <div className="row ">
              <div className="col-6 offset-6 col-md-12 offset-md-0 text-sm-right">
                { this.renderQuantityDropdown(product) }
              </div>
            </div>
          </div>
        );
      }
    })();

    const action = this.action(product);

    return (
      <div className='row price-and-create'>
        { $quantityDropdown }
        <div className="col-6 col-lg-12 product-price">
          <h2 className="price text-lg-right">
            { $price }
          </h2>
        </div>
      { this.renderCreateNow(action, $price) }
      </div>
    );
  },

  renderCreateNow(action, price) {
    const isMobile = (() => {
      if (typeof document !== 'undefined') {
        return document.documentElement.clientWidth < 768;
      }
  
      return false;
    })();

    if (isMobile) {
      return (
        <div className="row price-and-create-mobile">
          <div className="col-6 col-lg-12 product-price">
            <div className="price text-lg-right">
              { price }
            </div>
          </div>
          <div className="col-6 col-lg-12 create-now">
            {
              <ProgressButton href={ action }
                              className="btn btn-primary btn-lg btn-block create-now"
                              onClick={ this.props.onClick }>
                { this.renderProgressButtonLabel(action) }
              </ProgressButton>
            }
          </div>
        </div>
      );
    } else {
      return (
        <div className="col-6 col-lg-12 create-now">
          {
            <ProgressButton href={ action }
                            className="btn btn-primary btn-lg btn-block create-now"
                            onClick={ this.props.onClick }>
              { this.renderProgressButtonLabel(action) }
            </ProgressButton>
          }
        </div>
      );
    }
  },

  renderProgressButtonLabel(action) {
    return /^\/product\/add/.test(action) ? `Add to ${ translate('Cart') }` : 'Create Now';
  },

  renderQuantityDropdown(product) {
    const {copies} = this.props;

    return (
      <div className="row no-gutters align-items-center quantity">
        <label className="col mr-2" id="quantity-and-price-label">Quantity</label>
        <div className="dropup">
          <button className="btn btn-link dropdown-toggle"
                  role="combobox"
                  data-toggle="dropdown" aria-label="quantity">
            {copies}
          </button>
          <div className="dropdown-menu dropdown-menu-right"
                aria-labelledby="quantity-and-price-label">
            {
              (new QuantityPricingTools(product)).generateOptions().map(({product, quantity, unitPrice, cost}) => {
                const active = copies == quantity;

                return (
                  <button key={ quantity }
                          className={ classNames('btn btn-link dropdown-item', {active}) }
                          onClick={ this.handleCopiesChanged.bind(this, quantity) }>
                    <i className={ classNames('fas fa-check mr-2', {'invisible': !active}) } />
                    {quantity} {product} {Currency.format(cost)} <small>({Currency.format(unitPrice)} each)</small>
                  </button>
                );
              })
            }
          </div>
        </div>
      </div>
    );
  },

  renderPrice(product, displayWas) {
    const copies = this.props.copies;

    const { price, includeFrom } = (() => {
      const options = this.productOptions(product).filter(option => option.affectsPrice);

      if (options.length === 1) {
        const [option] = options;

        return {
          price: option.minimumPrice * copies,
          includeFrom: option.priceIsFrom
        };
      }

      const price = (() => {
        if (product.show_quantity_dropdown) {
          return (new QuantityPricingTools(product)).getUnitPriceForQuantity(copies) * copies;
        }

        return product.minimum_price;
      })();

      return {
        price,
        includeFrom: this.shouldDisplayFrom()
      };
    })();

    const wasPrice = (() => {
      if (!displayWas) {
        return;
      }

      const wasPrice = (product.was_price || []).reduce((memo, wp) => {
        if (wp.quantity <= copies) {
          return Object.assign({}, wp, {value: wp.value * copies});
        }

        return memo;
      }, {});

      if (genericHelpers.isWasPriceValid({ was_price: wasPrice, price })) {
        return wasPrice.value;
      }
    })();

    return (
      <Price now={ price }
             was={ wasPrice }
             includeFrom={ includeFrom }
             displayWas={ displayWas} />
    );
  },

  shouldDisplayFrom() {
    const productPrice = this.props.products[0].minimum_price;
    for (let i = 0; i < this.props.products.length; i++) {
      let product = this.props.products[i];
      if ((product.price_is_from) || (productPrice !== product.minimum_price)) {
        return true;
      }
    }
    return false;
  },

  productWithMinimumPrice() {
    return this.props.products.reduce((memo, product) => {
      return memo.minimum_price < product.minimum_price ? memo : product;
    });
  },

  action(product) {
    // Determines the Create Now button action
    const params = {
      theme: this.props.theme,
      copies: this.props.copies,
      selected_delivery_option: this.props.deliveryOption && this.props.deliveryOption.key
    };

    if (this.props.variantName) {
      params.variant_name = this.props.variantName;
    }

    if (this.props.selectedDeliveryOptions) {
      params.selected_delivery_option = this.props.selectedDeliveryOptions
    }

    if (product.is_calendar && this.props.calendar_start_date) {
      const date = new Date(this.props.calendar_start_date);
      params.yearSel  = date.getFullYear();
      params.monthSel = date.getMonth() + 1;
    }

    this.productOptions(product).forEach(option => {
      params['custom_' + option.key] = option.value.toLowerCase();
    });

    const queryString = UrlBuilder.buildURLQuery(params);
    if (product.action.includes('?')) {
      return product.action + '&' +  UrlBuilder.buildURLQuery(params);
    }

    return product.action + '?' + queryString;
  },

  productOptions(product) {
    return product.options.map(option => {
      const key = option.id,
      value = (this.props.options[key] && this.props.options[key].value) || option.options[0].value,
      subOption = option.options.find(option => option.value == value);

      return {
        key,
        value,
        affectsPrice: option.affects_price,
        minimumPrice: subOption.minimum_price,
        priceIsFrom:  subOption.price_is_from
      };
    });
  },

  handleCopiesChanged(value) {
    builderDispatch.dispatch({
      type: PrismUI.EVENT_QUANTITY_CHANGED,
      value
    });
  }
});

export default PriceAndProductCreate;
